import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=47c45a2c&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"
import style0 from "./Checkout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VForm,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\eLpass\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c45a2c')) {
      api.createRecord('47c45a2c', component.options)
    } else {
      api.reload('47c45a2c', component.options)
    }
    module.hot.accept("./Checkout.vue?vue&type=template&id=47c45a2c&", function () {
      api.rerender('47c45a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Checkout.vue"
export default component.exports